import * as React from "react";

function Search({color="var(--color-blue-500)",...props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 19 19" fill="none" {...props}>
      <path
        clipRule="evenodd"
        d="M8.575 16.163A7.576 7.576 0 011 8.58a7.576 7.576 0 1115.15 0 7.576 7.576 0 01-7.575 7.582z"
        stroke={color}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.102 14.094l3.742 3.405"
        stroke={color}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Search;
